import styled from "@emotion/styled";
import { fontAngkor, fontFredoka } from "@product/scmp-sdk";

import { BaseImage } from "~/components/common/base-image";
import { EntityLink } from "~/components/entity-link";

import Bubble from "./bubble.svg?url";
import LightBulb from "./light-bulb.svg?url";
import Star from "./star.svg?url";

export const StyledEntityLink = styled(EntityLink)`
  position: relative;
`;

export const StyledBaseImage = styled(BaseImage)`
  position: relative;

  margin-block-end: 24px;

  border-radius: 20px;

  overflow: hidden;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 32px;
  }
`;

export const StyledArticleMoreStoriesItem = styled.div`
  position: relative;

  flex: 1;

  max-inline-size: 360px;

  &:first-child ${StyledEntityLink}::after {
    inset-block-start: -5.5%;
    inset-inline-end: 0%;

    inline-size: 87px;
    block-size: 87px;
    max-inline-size: none;

    background-image: url(${Star});
    ${props => props.theme.breakpoints.up("desktop")} {
      inline-size: 84px;
      block-size: 84px;
    }

    ${props => props.theme.breakpoints.up("largeDesktop")} {
      inset-block-start: -8%;
      inset-inline-end: 0%;

      inline-size: 104px;
      block-size: 104px;
    }
  }

  &:nth-child(2) ${StyledEntityLink}::after {
    inset-block-end: 0;
    inset-inline-end: 0;

    inline-size: 104px;
    block-size: 94px;

    background-image: url(${Bubble});
    ${props => props.theme.breakpoints.up("desktop")} {
      inset-block-end: 0;
      inset-inline-start: 72.85%;

      inline-size: 80px;
      block-size: 72px;
    }

    ${props => props.theme.breakpoints.up("largeDesktop")} {
      inline-size: 124px;
      block-size: 113px;
    }
  }

  &:nth-child(3) ${StyledEntityLink}::after {
    inset-block-end: 2%;
    inset-inline-end: 2%;

    inline-size: 91px;
    block-size: 115px;

    background-image: url(${LightBulb});

    ${props => props.theme.breakpoints.up("desktop")} {
      inset-block-end: 17%;
      inset-inline-end: -13%;

      inline-size: 76px;
      block-size: 104px;
    }

    ${props => props.theme.breakpoints.up("largeDesktop")} {
      inline-size: 94px;
      block-size: 130px;
    }
  }

  &:not(:last-child) {
    margin-block-end: 30px;

    ${props => props.theme.breakpoints.up("desktop")} {
      margin-block-end: 0;
      margin-inline-end: 23px;
    }

    ${props => props.theme.breakpoints.up("largeDesktop")} {
      margin-inline-end: 30px;
    }
  }

  ${StyledEntityLink}::after {
    position: absolute;
    content: "";

    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: 360px;
  }
`;

export const Title = styled(EntityLink)`
  color: #333333;
  font-size: 24px;
  font-family: ${fontAngkor};
  line-height: 30px;
  letter-spacing: -0.03em;

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    font-size: 32px;
    line-height: 38px;
  }
`;

export const Section = styled(EntityLink)`
  margin-block-end: 16px;
  padding-block: 8px;
  padding-inline: 16px;

  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 22.4px;
  letter-spacing: 0.05em;
  text-align: center;
  text-transform: uppercase;

  border-radius: 8px;

  background: #ff7c1d;
`;
